import { Link } from 'react-router-dom';
import './legalDoc.css';

export function LegalChrome({ children }: { children: React.ReactNode }) {
  return (
    <div className="legal-root">
      <main className="legal-main">
        <Link to="/" className="legal-home">
          ← Kynward home
        </Link>
        {children}
      </main>
    </div>
  );
}
